export default [
	{
		type: "special",
		id: 1,
		items: [
			{
				id: 1,
				text: "Studienfach",
				label: [
					{
						id: 1,
						text: "Mechatronik",
					},
					{
						id: 2,
						text: "Systems Engineering",
					},
					{
						id: 3,
						text: "Quantum Engineering",
					},
					{
						id: 4,
						text: "MWWT",
					},
					{
						id: 5,
						text: "MuN",
					},
					{
						id: 6,
						text: "CuK/Embedded Systems",
					},
					{
						id: 7,
						text: "LA Technik",
					},
					{
						id: 8,
						text: "Informatik",
					},
					{
						id: 9,
						text: "Sonstiges",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 2,
				type: "medium",
				text: "Es bestand eine terminliche Kollision mit:",
			},
			{
				id: 3,
				text: "Wurden Vorkenntnisse vorausgesetzt, die Ihnen gefehlt haben? Wenn ja, welche?",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		title: "Evaluation der Vorlesung",
		items: [
			{
				id: 4,
				text: "Die Vorlesung ist gut gegliedert.",
			},
			{
				id: 5,
				text: "Die Vorlesungs-Hilfsmittel (Skripte) sind hilfreich.",
			},
			{
				id: 6,
				text: "Die Inhalte sind anschaulich (Beispiele).",
			},
			{
				id: 7,
				text: "Der Dozent/Die Dozentin kann Inhalte gut vermitteln.",
			},
			{
				id: 8,
				text: "Der Dozent/Die Dozentin ist auf jede Vorlesung gut vorbereitet.",
			},
			{
				id: 9,
				text: "Der Dozent/Die Dozentin begeistert mich für das Fach.",
			},
		],
	},
	{
		type: "uni",
		id: 4,
		title: "Evaluation der Übung",
		items: [
			{
				id: 10,
				text: "Die Übungsaufgaben sind klar verständlich.",
			},
			{
				id: 11,
				text: "Die Anforderungen im Übungsbetrieb sind angemessen.",
			},
			{
				id: 12,
				text: "Übung und Vorlesung sind gut aufeinander abgestimmt.",
			},
			{
				id: 13,
				text: "Rückfragen werden problemlos beantwortet.",
			},
			{
				id: 14,
				text: "Der/Die Übungsleiter/in kann Inhalte gut vermitteln.",
			},
			{
				id: 15,
				text: "Der/Die Übungsgruppenleiter/in ist auf jede Übung gut vorbereitet.",
			},
			{
				id: 16,
				text: "Der/Die Übungsgruppenleiter/in geht auf Fragen genügend ein.",
			},
		],
	},
	{
		type: "uni",
		id: 5,
		title: "Gesamtbewertung",
		items: [
			{
				id: 17,
				text: "Die Veranstaltung verfolgt ein klares Ziel (roter Faden).",
			},
			{
				id: 18,
				text: "Die Räume sind in Ordnung.",
			},
			{
				id: 19,
				text: "Webinfos zur Veranstaltung sind gut erhätlich.",
			},
			{
				id: 20,
				text: "Die Organisation von VL und Übungsbetrieb ist gelungen.",
			},
			{
				id: 21,
				text: "Die Kriterien zur Erlangung des Leistungsnachweises wurden von vorneherein gut definiert.",
			},
			{
				id: 22,
				text: "Die Kriterien zur Erlangung des Leistungsnachweises sind transparent.",
			},
			{
				id: 23,
				text: "Die Kriterien zur Erlangung des Leistungsnachweises sind angemessen.",
			},
			{
				id: 24,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit dem / der Dozenten/in.",
			},
			{
				id: 25,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit anderen Studierenden.",
			},
			{
				id: 26,
				text: "Die Online-Termine waren gut organisiert und leicht erreichbar.",
			},
			{
				id: 27,
				text: "Die Online-Materialien (z.B. Texte, Quizzes, Videos etc.) haben wesentlich zum Verständnis der Lerninhalte beigetragen.",
			},
			{
				id: 28,
				text: "Die Möglichkeiten digitaler Lehre über traditionelle Lehre hinaus (Diskussionsforen, interaktive Aufgaben etc.) wurden gut genutzt.",
			},
			{
				id: 29,
				text: "Insgesamt waren die digitalen Elemente der Veranstaltung gut.",
			},
			{
				id: 30,
				text: "Die Veranstaltung ist ein Beispiel für gute digitale Lehre.",
			},
		],
	},
	{
		type: "bi",
		id: 5,
		items: [
			{
				id: 31,
				text: "Der Umfang des Stoffes war...",
			},
			{
				id: 32,
				text: "Das Tempo der Veranstaltung war...",
			},
			{
				id: 33,
				text: "Die Anforderungen der Veranstaltung waren...",
			},
		],
	},
	{
		type: "text",
		id: 6,
		items: [{ id: 34, type: "small", text: "Durchschnittlicher Aufwand für die Veranstaltung (VL, Übung, Vor- und Nachbereitung und ggf. Bonuspunkte) in Stunden pro Woche:" }],
	},
	{
		type: "special",
		id: 7,
		items: [
			{
				id: 35,
				text: "Sind die Bonuspunkte bis zum Beginn der Lehrveranstaltung im nächsten Turnus gültig?",
				label: [
					{
						id: 1,
						text: "ja",
					},
					{
						id: 2,
						text: "nein",
					},
				],
			},
			{
				id: 36,
				text: "Ist es möglich, ohne Bonuspunkte die Note 'sehr gut (1,0)' zu erhalten?",
				label: [
					{
						id: 1,
						text: "ja",
					},
					{
						id: 2,
						text: "nein",
					},
				],
			},
			{
				id: 37,
				text: "Insgesamt bewerte ich die Veranstaltung mit der Note",
				label: [
					{
						id: 1,
						text: "sehr gut",
					},
					{
						id: 2,
						text: "gut",
					},
					{
						id: 3,
						text: "befriedigend",
					},
					{
						id: 4,
						text: "ausreichend",
					},
					{
						id: 5,
						text: "mangelhaft",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 8,
		items: [
			{
				id: 38,
				text: "Was war gut an der Veranstaltung, bzw. was sollte unbedingt bleiben?",
			},
			{
				id: 39,
				text: "Was war schlecht an der Veranstaltung, bzw. was sollte unbedingt geändert werden?",
			},
		],
	},
];
